<template>
  <div>
    <app-panel title="Текущее состояние базы">
      <div>
        <InfoBlock title="Платежи с кривыми датами назначения" v-if="paymentsInfo.target_date_fails.length">
          <ul class="check-source-stage-info-tags">
            <li v-for="payment in targetDAteFailsByPage" :key="payment.id">
              {{payment.id}} ({{payment.monthyear}})
            </li>
          </ul>
          <div style="margin-top: 30px;">
            <vs-pagination :total="targetDateFailsTotal" v-model="targetDateFailsPage" />
          </div>
        </InfoBlock>

        <InfoBlock title="Платежи с кривыми датами прохождения" v-if="paymentsInfo.passage_date_fails.length">
          <ul class="check-source-stage-info-tags">
            <li v-for="payment in passageDateFailsByPage" :key="payment.id">
              {{payment.id}} ({{payment.passage_date}})
            </li>
          </ul>
          <div style="margin-top: 30px;">
            <vs-pagination :total="passageDateFailsTotal" v-model="passageDateFailsPage" />
          </div>
        </InfoBlock>

        <InfoBlock title="Типы приборов в базе" v-if="stageInfo.device_types.length">
          <ul class="check-source-stage-info-tags">
            <li v-for="deviceType in stageInfo.device_types" :key="deviceType.device_type">
              {{deviceType.device_type}}
            </li>
          </ul>
        </InfoBlock>

        <InfoBlock title="Типы приборов без показаний" v-if="stageInfo.no_values_device_types.length">
          <ul class="check-source-stage-info-tags">
            <li v-for="deviceType in stageInfo.no_values_device_types" :key="deviceType.device_type">
              {{deviceType.device_type}}
            </li>
          </ul>
        </InfoBlock>

        <InfoBlock title="Квартиры с пробелом в номере" v-if="stageInfo.flat_with_space_ids.length">
          <ul class="check-source-stage-info-tags">
            <li v-for="flat in stageInfo.flat_with_space_ids" :key="flat.id">
              {{flat.id}}
            </li>
          </ul>
        </InfoBlock>

        <InfoBlock v-if="stageInfo.multiple_owners_accounts.length"
                   title="Аккаунты возможно с несколькими собственниками"
                   subtitle="Проверь и составь список разделителей имен в промежуточной базе">
          <ul class="check-source-stage-info-tags">
            <li v-for="account in stageInfo.multiple_owners_accounts" :key="account.account">
              {{account.account}}
            </li>
          </ul>
        </InfoBlock>

        <InfoBlock v-if="stageInfo.repeated_raw_flats.length" title="Квартиры с повторяющими номерами"
                   subtitle="Исправь номера квартир в таблицах &lt;flats&gt;, &lt;accounts&gt;, &lt;individual_counters&gt;">
          <ul class="check-source-stage-info-tags">
            <li v-for="flat in stageInfo.repeated_raw_flats" :key="flat">
              {{flat}}
            </li>
          </ul>
        </InfoBlock>

        <InfoBlock v-if="stageInfo.repeated_flats.length" title="Повторящиеся сочетания номера и типа помещения">
          <ul class="check-source-stage-info-tags check-source-stage-info-tags_full">
            <li v-for="flat in stageInfo.repeated_flats" :key="flat">
              {{flat}}
            </li>
          </ul>
        </InfoBlock>

        <InfoBlock v-if="stageInfo.flats_with_slash.length" title="Квартиры с слэшем в номере">
          <ul class="check-source-stage-info-tags">
            <li v-for="flat in stageInfo.flats_with_slash" :key="flat">
              {{flat}}
            </li>
          </ul>
        </InfoBlock>

      </div>
    </app-panel>
  </div>
</template>

<script>
  import InfoBlock from "./components/InfoBlock";

  const TAGS_IN_PAGE = 50;

  export default {
    name: "CheckSourceStageInfo",
    props: {
      importInfo: {}
    },
    components: {
      InfoBlock
    },
    data() {
      return {
        TAGS_IN_PAGE: TAGS_IN_PAGE,
        stageInfo: {
          device_types: [],
          no_values_device_types: [],
          flat_with_space_ids: [],
          multiple_owners_accounts: [],
          repeated_flats: [],
          flats_with_slash: [],
          repeated_raw_flats: []
        },
        paymentsInfo: {
          target_date_fails: [],
          passage_date_fails: []
        },
        targetDateFailsPage: 1,
        targetDateFailsTotal: 1,
        passageDateFailsPage: 1,
        passageDateFailsTotal: 1,
      }
    },
    computed: {
      targetDAteFailsByPage() {
        return this.paymentsInfo.target_date_fails.slice((this.targetDateFailsPage - 1) * this.TAGS_IN_PAGE, this.targetDateFailsPage * this.TAGS_IN_PAGE);
      },
      passageDateFailsByPage(){
        return this.paymentsInfo.passage_date_fails.slice((this.passageDateFailsPage - 1) * this.TAGS_IN_PAGE, this.passageDateFailsPage * this.TAGS_IN_PAGE);
      }
    },
    methods: {
      resetStageInfo() {
        this.stageInfo = {
          device_types: [],
          no_values_device_types: [],
          flat_with_space_ids: [],
          multiple_owners_accounts: [],
          repeated_flats: [],
          flats_with_slash: [],
          repeated_raw_flats: []
        };
      },
      resetPaymentsInfo() {
        this.paymentsInfo = {
          target_date_fails: [],
          passage_date_fails: []
        };
        this.targetDateFailsPage = 1;
        this.targetDateFailsTotal = 1;
        this.passageDateFailsPage = 1;
        this.passageDateFailsTotal = 1;
      },
      async getStagePayments() {
        try {
          let {data} = await this.$http.get('import/houses/stage_2_invoices', {
            params: {
              import_id: this.importInfo.id
            }
          });
          this.paymentsInfo = data;
          this.targetDateFailsPage = 1;
          this.targetDateFailsTotal = Math.ceil(this.paymentsInfo.target_date_fails.length / this.TAGS_IN_PAGE);
          this.passageDateFailsPage = 1;
          this.passageDateFailsTotal = Math.ceil(this.paymentsInfo.passage_date_fails.length / this.TAGS_IN_PAGE);
        } catch (e) {
          this.resetPaymentsInfo();
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      },
      async getStageInfo() {
        try {
          let {data} = await this.$http.get('import/houses/stage_2', {
            params: {
              import_id: this.importInfo.id
            }
          });
          Object.assign(this.stageInfo, data);
        } catch (e) {
          this.resetStageInfo();
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      }
    },
    created() {
      this.resetStageInfo();
      this.resetPaymentsInfo();
    },
    beforeMount() {
      this.getStageInfo();
      this.getStagePayments();
    }
  }
</script>

<style lang="scss">
  .check-source-stage-info-tags {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -10px;
    margin-right: -10px;

    li {
      line-height: 1.1;
      background: rgba(0, 0, 0, .1);
      padding: 8px 10px;
      font-size: 12px;
      margin: 0 10px 10px 0;
      border-radius: 5px;
      font-weight: 500;
    }

    &_full{
      flex-direction: column;
    }
  }
</style>
